import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'normalizeNewLines',
  standalone: false,
})
export class NormalizeNewLinesPipe implements PipeTransform {
  transform(value: string | null): string | null {
    if (value == null) {
      return null
    }

    return value
      .replace(/\\n/g, '\n')
      .replace(/\r\n|\r/g, '\n')
      .replace(/\n /g, '\n')
      .replace(/\n{1,2}/g, '\n')
      .replace(/\n{3,}/g, '\n\n')
      .replace(/^\n+|\n+$/g, '')
  }
}
